import { t } from 'ttag';

import { useRegion } from '@hook/useRegion';
import { ActiveFilter } from '@ui/ActiveFilter';
import { useProductFilters, FilterKeys } from '@hook/productFilters';

import s from './ActiveFilters.sss';

type ActiveFiltersProps = {
  sizeCatalogSlug?: string | null;
  dynamicCollectionSlug?: string | null;
  className?: string
};

export const ActiveFilters: React.FC<ActiveFiltersProps> = ({
  sizeCatalogSlug,
  dynamicCollectionSlug,
  className,
}) => {
  const region = useRegion();
  const {
    setFilter,
    activeFilters,
    clearAllFilters,
    hasFilters,
    rawActiveFilters,
  } = useProductFilters({
    catalogSlug: sizeCatalogSlug,
    dynamicCollectionSlug,
  });
  const {
    priceFrom,
    priceTo,
    searchText,
    ukrainian,
  } = activeFilters;

  const removeFilter = (name: FilterKeys, value?: string | number) => () => {
    const oldValue = rawActiveFilters[name];
    if (Array.isArray(oldValue)) {
      setFilter({ [name]: [...oldValue].filter((v) => String(v) !== String(value)) });
    } else {
      setFilter({ [name]: undefined });
    }
  };

  return (
    (
      <div className={className}>
        {ukrainian && (
          <ActiveFilter
            className={s.filter}
            onClick={removeFilter('ukrainian')}
          >
            Зроблено в Україні
          </ActiveFilter>
        )}
        {
          activeFilters.brands.map(
            (brand) => (
              <ActiveFilter
                key={brand.id}
                className={s.filter}
                onClick={removeFilter('brands', brand.id)}
              >
                {brand.name}
              </ActiveFilter>
            ),
          )
        }
        {
          activeFilters.colors.map(
            (color) => (
              <ActiveFilter
                key={color.id}
                className={s.filter}
                onClick={removeFilter('colors', color.id)}
              >
                {color.name}
              </ActiveFilter>
            ),
          )
        }
        {
          activeFilters.conditions.map(
            (condition) => (
              <ActiveFilter
                key={condition.id}
                className={s.filter}
                onClick={removeFilter('conditions', condition.id)}
              >
                {condition.name}
              </ActiveFilter>
            ),
          )
        }
        {
          activeFilters.sizes.map(
            (size) => (
              <ActiveFilter
                key={size.id}
                className={s.filter}
                onClick={removeFilter('sizes', size.id)}
              >
                {size.secondarySizeName || size.primarySizeName}
              </ActiveFilter>
            ),
          )
        }
        {
          activeFilters.cities.map(
            (city) => (
              <ActiveFilter
                key={city.id}
                className={s.filter}
                onClick={removeFilter('cities', city.id)}
              >
                {city.name}
              </ActiveFilter>
            ),
          )
        }
        {
          activeFilters.prices.map(
            (price) => (
              <ActiveFilter
                key={price.id}
                className={s.filter}
                onClick={removeFilter('prices', price.id)}
              >
                {price.name}
              </ActiveFilter>
            ),
          )
        }
        {priceFrom && (
          <ActiveFilter
            className={s.filter}
            onClick={removeFilter('priceFrom')}
          >
            {t`Від ${priceFrom}`}
            {' '}
            {region.currencyName}
          </ActiveFilter>
        )}
        {priceTo && (
          <ActiveFilter
            className={s.filter}
            onClick={removeFilter('priceTo')}
          >
            {t`До ${priceTo}`}
            {' '}
            {region.currencyName}
          </ActiveFilter>
        )}
        {searchText && (
          <ActiveFilter
            className={s.filter}
            onClick={removeFilter('searchText')}
          >
            {searchText}
          </ActiveFilter>
        )}
        {activeFilters.freeShipping && (
          <ActiveFilter
            className={s.filter}
            onClick={removeFilter('freeShipping')}
          >
            {t`Безкоштовна доставка`}
          </ActiveFilter>
        )}
        {activeFilters.isOnSale && (
          <ActiveFilter
            className={s.filter}
            onClick={removeFilter('isOnSale')}
          >
            {t`Знижка`}
          </ActiveFilter>
        )}
        {
          activeFilters.characteristics.map(
            ({ id, title }) => (
              <ActiveFilter
                key={id}
                className={s.filter}
                onClick={removeFilter('characteristics', id)}
              >
                {title}
              </ActiveFilter>
            ),
          )
        }
        {hasFilters && (
          <ActiveFilter className={s.clearAll} onClick={clearAllFilters}>
            {t`Скинути фільтри`}
          </ActiveFilter>
        )}
      </div>
    )
  );
};
